import { DataTable } from '../../../components/UI/MDC/DataTable/DataTable';
import styles from '../IMSLDAPValidator.module.scss'
import { nanoid } from 'nanoid';

const IMSResults = (imsResults) => {

    const headers = [
        { Value: "Name", props: { sort: null, onSortChange: null } },
        { Value: "Title", props: { sort: null, onSortChange: null } },
        { Value: "Department", props: { sort: null, onSortChange: null } },
        { Value: "Account Type", props: { sort: null, onSortChange: null } },
        { Value: "Employee ID", props: { sort: null, onSortChange: null } },
    ];

    const rows = Object.entries(imsResults).map(([key, data]) => {
        return {
            Cells: {
                Name: {
                    Value: data.Name,
                    Validation: {
                        Key: 'true',
                        Value: null,
                        memberToValidateKey: null,
                    },
                },
                Title: {
                    Value: data.Title,
                    Validation: {
                        Key: 'true',
                        Value: null,
                        memberToValidateKey: null,
                    },
                },
                Department: {
                    Value: data.Department,
                    Validation: {
                        Key: 'true',
                        Value: null,
                        memberToValidateKey: null,
                    },
                },
                "Account Type": {
                    Value: data.EmployeeType,
                    Validation: {
                        Key: 'true',
                        Value: null,
                        memberToValidateKey: null,
                    },
                },
                "Employee ID": {
                    Value: data.EmployeeID,
                    Validation: {
                        Key: 'true',
                        Value: null,
                        memberToValidateKey: null,
                    },
                },
            },
            Key: nanoid(),
        };
    });

    return (
        <DataTable
            rows={rows}
            headers={headers}
            className={styles.Table_Overrides}
        />   
    )
}

export default IMSResults